<template>
    <div>
      <button
        class="w-100 salesflow-btn salesflow-btn-primary"
        :disabled="success || submitting || disabled"
        @click="() => $emit('advance')"
      >
        {{ text }}
      </button>
    </div>
  </template>

  <script>
  export default {
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
      submitting: {
        type: Boolean,
        default: false,
      },
      success: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      text () {
        if (this.success) {
          return this.__('Pagamento realizado');
        }

        if (this.submitting) {
          return this.__('Aguarde') + '...';
        }

        return this.__('Finalizar compra');
      },
    },
  };
  </script>

  <style lang="scss">
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  .container-confirmation-upgrade-plan-swal {
    .fs-5 {
      font-size: 1rem;
    }

    .fs-6 {
      font-size: 0.75rem;
    }

    .text-black {
      color: #0E0F18;
    }

    .swal2-modal {
      width: 607px;
      border-radius: 16px;
      padding-bottom: 48px;
      background-color: #F8F8F8;

      .swal2-icon {
        margin-top: 48px;
      }

      h2 {
        @include salesflow-subtitle($font-weight: 700);
        font-size: 1rem;
        margin-bottom: 0px;
      }

      .info-container {
        width: 495px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 1rem 0.5rem;
        margin: auto;
        border: 1px solid #D1D1D1;
        border-radius: 16px;
        background-color: white;

        .info-title {
          @include salesflow-text($color: #71767D);
        }

        .info-value {
          @include salesflow-text($font-weight: 600);
        }
      }

      .swal2-actions {
        margin-top: 24px;
      }
    }
  }
</style>
